





















import { Vue, Component } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { getLangType } from '@/api/common'

@Component({
  name: 'ContentNews'
})
export default class extends Vue {
  showNav = true

  created() {
    if (this.languageList.length <= 0) {
      getLangType().then((res: any) => {
        AppModule.GetLanguages(res.data)
      })
    }
  }

  get editPage() {
    const activeArr: string[] = ['NewsAdd', 'NewsEdit', 'TagEdit']
    return activeArr.includes(this.$route.name as string)
  }

  get languageList() {
    return AppModule.languageList
  }
}
